import { render } from "./GridContainer.vue?vue&type=template&id=4979a68a&scoped=true&ts=true"
import script from "./GridContainer.vue?vue&type=script&lang=ts"
export * from "./GridContainer.vue?vue&type=script&lang=ts"

import "./GridContainer.vue?vue&type=style&index=0&id=4979a68a&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979a68a"]])

export default __exports__